(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-price"] && !Shopify.designMode) return;
  try {
    (() => {
    const formatRetreatPrices = () => {
      document.querySelectorAll('[data-pa-retreat-currency="USD"]').forEach((price) => {
        const current = price.textContent.trim();
        const formatted = current.replace(/[.,]00$/, '');
        if (formatted !== current) price.textContent = formatted;
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', formatRetreatPrices, { once: true });
    } else {
      formatRetreatPrices();
    }

    document.addEventListener('theme:variant:change', formatRetreatPrices);
    document.addEventListener('shopify:section:load', formatRetreatPrices);
  })();
  } catch(e) { console.error(e); }
})();

})();
